import React from 'react';
import '../styles/SoldOut.css';

const translations = {
  en: {
    title: "Contact us to learn more: ",
    whatsappMessageText: "Terrenos Puerto Escondido: I want more information about: "
  },
  es: {
    title: "Contáctanos para obtener más información: ",
    whatsappMessageText: "Terrenos Puerto Escondido: Quiero más información de: "
  }
};

const WhatsappCTA = ({ language }) => {


  const whatsappNumber = '+529618880654';
  const whatsappMessage = translations[language].whatsappMessageText;

    return (

        <div className='whatsapp-CTAN'>


            <h2>{translations[language].title}</h2>
            <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-iconN"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M19.077 4.928C17.191 3.041 14.683 2.001 12.044 2c-5.459 0-9.917 4.357-9.917 9.821 0 1.792.473 3.53 1.368 5.073L2 22l5.218-1.313c1.453.838 3.11 1.289 4.828 1.289 5.459 0 9.917-4.357 9.917-9.821-.001-2.639-1.04-5.147-2.886-7.047zM12.044 20.007c-1.659 0-3.259-.51-4.595-1.471l-.334-.198-3.458.87.924-3.377-.217-.342c-.955-1.569-1.463-3.391-1.463-5.324 0-4.379 3.582-7.942 7.989-7.942 2.134 0 4.126.817 5.627 2.3 1.5 1.482 2.324 3.443 2.324 5.525-.001 4.368-3.582 7.941-7.989 7.941zm5.336-6.211c-.298-.15-1.758-.867-2.03-.967-.272-.099-.471-.148-.67.15-.198.298-.767.966-.94 1.164-.173.199-.347.223-.644.075-.298-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.298-.018-.46.13-.606.134-.133.298-.347.447-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.521-.075-.149-.67-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.298-1.04 1.007-1.04 2.455 0 1.447 1.06 2.85 1.208 3.049.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            </svg>
          </a>
        </div>
    );
};

export default WhatsappCTA;